<template>
  <svg
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L10 10L18 2"
      stroke="currentColor"
      stroke-width="2.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
